import React from 'react';
import './Logo.css';

const Logo = ({ size = 48 }) => {
  // TO USE YOUR ACTUAL LOGO IMAGE:
  // 1. Save your logo image as "logo.png" in the public folder
  // 2. It will automatically appear here
  const logoUrl = "/logo.png";

  return (
    <div className="logifox-logo" style={{ width: size, height: size }}>
      <img 
        src={logoUrl}
        alt="Logifox Infotech Logo" 
        style={{ 
          width: '100%', 
          height: '100%', 
          objectFit: 'contain',
          display: 'block'
        }}
      />
    </div>
  );
};

export default Logo;
